import DynamicPage from 'components/DynamicPage';

const CreatorSupport = () => {
  return(
    <DynamicPage url="/creator-support" />
  )
}

export default CreatorSupport;
